import './Legend.css'

import PropTypes from 'prop-types'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { formatNumberWithCurrency } from 'utils'

function Legend({ colors, currency = '', usePercentages = false }) {
  const { t: translate } = useTranslation()

  return (
    <div className="legend">
      {colors.map(({ color, min }) => (
        <div className="legend-color" key={color}>
          <div className="legend-color-indicator" style={{ background: color }} />
          <div className="legend-color-value">
            {min === 0 && `>= 0${usePercentages ? '%' : ''}`}
            {min > 0 &&
              `> ${formatNumberWithCurrency({
                currency: usePercentages ? '%' : currency,
                number: min,
                translate,
              })}`}
          </div>
        </div>
      ))}
    </div>
  )
}

Legend.propTypes = {
  colors: PropTypes.arrayOf(
    PropTypes.shape({
      color: PropTypes.string,
      max: PropTypes.number,
      min: PropTypes.number,
    }),
  ).isRequired,
  currency: PropTypes.string,
  usePercentages: PropTypes.bool,
}

export default Legend
